import { render, staticRenderFns } from "./editPT.vue?vue&type=template&id=185493f9&scoped=true&"
import script from "./editPT.vue?vue&type=script&lang=js&"
export * from "./editPT.vue?vue&type=script&lang=js&"
import style0 from "./editPT.vue?vue&type=style&index=0&id=185493f9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185493f9",
  null
  
)

export default component.exports